import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components'
import { typeface, get_color } from '../../assets/styles';
import imgChevronUpGreen from '../../assets/images/icn_stroke_chevron_up_hase_green.svg';
import imgChevronDownGreen from '../../assets/images/icn_stroke_chevron_down_hase_green.svg';
import imgChevronDownGrey from '../../assets/images/icn_stroke_chevron_down_grey02.svg';

const AccordionItem = styled('div') <{isActive : boolean, bodyHeight: number}>`
  border-bottom: 1px solid ${get_color('divider')};
  .accordion-button{
    ${typeface('body5')}
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: ${get_color('white')};
    border: none;
    color: ${props => props.isActive ? get_color('green01') : get_color('grey01')};
    cursor: pointer;
    padding: 16px 0;
    text-align: left;
    &:after{
      content: "";
      background-image: url(${props => props.isActive ? imgChevronUpGreen : imgChevronDownGrey});
      display: inline-block;
      width: 20px;
      height: 20px;
      background-size: cover;
      margin-left: 16px;
    }
    &:hover{
      color: ${get_color('green01')};
      ${props => !props.isActive && 
        `&:after{
          background-image: url(${imgChevronDownGreen});
        }`
      }
    }
  }
  .accordion-collapse{
    height: ${props => props.isActive ? props.bodyHeight + 'px' : '0'};
    overflow: hidden;
    transition: all 0.5s ease-in-out;
  }
  .accordion-body{
    ${typeface('body7')}
    padding: 0 36px 16px 22px;  
  }
`;

const AccordionPrefix  = styled('div')`
  padding-right: 4px;
`

const AccordionLabel  = styled('div')`
  flex: 1;
`

interface AccordionProps {
  prefix?: string;
  title: string;
  children: React.ReactElement;
}

const Accordion: React.FC<AccordionProps> = (props) => {
  const [isActive, setIsActive] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [bodyHeight, setBodyHeight] = useState<number>(0);
  
  const resizeHandler = () => {
    if (ref.current != null) {
      setBodyHeight(ref.current.clientHeight);
    }
  }

  useEffect(() => {
    window.addEventListener("resize", () =>{
      resizeHandler();
    })
    resizeHandler();
  },[])

  return (
      <AccordionItem isActive={isActive} bodyHeight={bodyHeight}>
        <div role="heading" aria-level={3}>
        <button aria-expanded={isActive} className="accordion-button" onClick={() => setIsActive(!isActive)}>
            {props.prefix && (
              <AccordionPrefix aria-hidden="true">
                {props.prefix}
              </AccordionPrefix>
            )}
            <AccordionLabel>{props.title}</AccordionLabel>
          </button>
        </div>
        <div className="accordion-collapse">
          <div className="accordion-body" ref={ref} aria-hidden={!isActive}>
            {props.children}
          </div>
        </div>
      </AccordionItem>
  );
}

export default Accordion;
